import config from "./gameConfigCommon.json";
import { CommonConfigData } from "./gameConfigCommonInterface";

export type MarketCode = "def" | "es" | "nl";

const marketKeyMap: Record<MarketCode, keyof typeof config> = {
  def: "belgianConfig",
  es: "spanishConfig",
  nl: "nederlandsConfig",
};

const DEFAULT_MARKET_CODE: MarketCode = "def";

export function getCommonConfig(marketId?: string): CommonConfigData {
  const normalizedId = marketId?.toLowerCase() as MarketCode;
  const configKey =
    marketKeyMap[normalizedId] || marketKeyMap[DEFAULT_MARKET_CODE];
  return config[configKey];
}

export function isValidMarketCode(
  code: string | undefined
): code is MarketCode {
  return !!code && Object.keys(marketKeyMap).includes(code.toLowerCase());
}

export { DEFAULT_MARKET_CODE };
